import "../styles.css";
import { MdRestore, MdDelete } from "react-icons/md";
import { useTrash } from "../context";
import { Toaster } from "react-hot-toast";

export default function Trash() {
  const { trash, removeFromTrashHandler, restoreFromTrashHandler } = useTrash();

  return (
    <div className="Label">
      <div className="label-header">
        <h4>Trash</h4>
      </div>
      {trash < 1 ? (
        <p className="p3 bold center">There is no task in Trash.</p>
      ) : (
        <ul className="flex-col">
          {trash &&
            trash.map((note) => {
              return (
                <li className="card">
                  <div className="card__primary-action card__primary-action-column">
                    <div className="card__primary">
                      <h2 className="p3 bold">{note.title}</h2>
                      <p className="p2">{note.body}</p>
                      <ul className="flex card-badges">
                        {note.tags &&
                          note.tags.map((tag, index) => {
                            return (
                              <li key={index} className="tag">
                                <span className="tag-title">{tag}</span>
                              </li>
                            );
                          })}
                      </ul>
                      <div className="flex flex-align-end">
                        <p className=" p1 bold">{note.timer} Min</p>
                      </div>
                    </div>
                  </div>
                  <div className="card__actions">
                    <p className="text-grey p1">Created on {note.date}</p>
                    <div className="card__action-icons p3 text-grey">
                      <MdRestore
                        name="restore item"
                        className="ptr"
                        title="Restore"
                        onClick={() => restoreFromTrashHandler(note, note._id)}
                      />

                      <MdDelete
                        name="remove item"
                        className="ptr"
                        title="Remove"
                        onClick={() => removeFromTrashHandler(note, note._id)}
                      />
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
      )}
      <Toaster position="bottom-right" reverseOrder={true} />
    </div>
  );
}
